<template>
    <div class="main-container">
        <AppToolbar></AppToolbar>
        <v-main>
            <router-view></router-view>
        </v-main>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import AppToolbar from './AppToolbar.vue'

export default {
    name: 'ProjectTemplate',
    components: {
        AppToolbar
    },
    computed: {
        ...mapState({
            token: state => state.user.token
        })
    }
}
</script>
<style scoped>
    .active_navigation i, .active_navigation .v-list__tile__title {
        color: #1976d2 !important;
        /*font-weight: bold;*/
    }

    .active_navigation .v-list__tile__title {
        font-weight: bold;
    }

    .main-container {
        background: #edf0f5;
        min-height: 100%;
    }
</style>
